import Notify from "../../../../src/content/projects/grab-design-system/Notify";
import * as React from 'react';
export default {
  Notify,
  React
};